"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.useRelativeTime = exports.isCredibleDate = exports.formatter = void 0;
var _formatter = _interopRequireDefault(require("./formatter"));
exports.formatter = _formatter["default"];
var _isCredibleDate = _interopRequireDefault(require("./is-credible-date"));
exports.isCredibleDate = _isCredibleDate["default"];
var _relativeTime = _interopRequireDefault(require("./relative-time"));
exports.useRelativeTime = _relativeTime["default"];